import { AdditionalForceData } from "gamevy/integration/builders/requests/force-request-payload";

class GamevyForceData {
    protected forceData?: AdditionalForceData;

    public setForceData(n: AdditionalForceData): void {
        this.forceData = n;
    }

    public clearForceData(): void {
        this.forceData = undefined;
    }

    public getForceData(): AdditionalForceData | undefined {
        return this.forceData;
    }
}

export const gamevyForceData = new GamevyForceData();
